import { useState } from 'react';
import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import { useVideoSource } from '@src/stores-v2';

interface UseFullscreenTransitionResult {
  showTransitionOverlay: boolean;
  makeFullScreen: () => Promise<void>;
  exitFullScreen: () => void;
}

const TRANSITION_DURATION = 1000;

export function useFullscreenTransition(): UseFullscreenTransitionResult {
  const videoCreator = useVideoCreatorStore();
  const videoSource = useVideoSource();
  const [showTransitionOverlay, setShowTransitionOverlay] = useState(false);

  const makeFullScreen = async () => {
    if (videoCreator.isPlayerFullScreen) {
      return;
    }

    const wasActive = videoCreator.reframingModeManager.isModeActive();
    await videoCreator.reframingModeManager.exitReframingMode();

    videoCreator.isPlayerFullScreen = true;

    if (wasActive) {
      setShowTransitionOverlay(true);
      videoSource.onNextStateChange(() => {
        videoCreator.renderer?.setMode('player');
      });
      setTimeout(() => {
        setShowTransitionOverlay(false);
      }, TRANSITION_DURATION);
    } else {
      videoCreator.renderer?.setMode('player');
    }
  };

  const exitFullScreen = () => {
    videoCreator.renderer?.setMode('interactive');
    videoCreator.isPlayerFullScreen = false;
    videoCreator.renderer?.setTool('text');
    setShowTransitionOverlay(false);
  };

  return {
    showTransitionOverlay,
    makeFullScreen,
    exitFullScreen,
  };
}
